import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import * as Sentry from '@sentry/angular';
import {environment} from './environments/environment';

if (environment.production) {

  Sentry.init({
    dsn: 'https://eef26487d51d2a67ef9a6aabe333002a@sentry.yurest.dev/14',
    environment: 'production',
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
      }),
    ],
    tracesSampleRate: 0.5,
  });

  enableProdMode();

}

window.addEventListener('error', (event) => {
  Sentry.captureException(event.error || new Error(event.message));
});

window.addEventListener('unhandledrejection', (event) => {
  const error: Error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  Sentry.captureException(error);
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
